import { render } from "./TheAmenities.vue?vue&type=template&id=7a0354f4&scoped=true"
import script from "./TheAmenities.vue?vue&type=script&lang=js"
export * from "./TheAmenities.vue?vue&type=script&lang=js"

import "./TheAmenities.vue?vue&type=style&index=0&id=7a0354f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0354f4"]])

export default __exports__